import React, { useState } from "react";
import { toast } from "react-toastify";

import { useForm, Controller } from "react-hook-form";

import UIRangeControl from "../../../UI/RangeControl";
import { startGame, FetchResult } from "../../../../services/GameService";
import { useHistory } from "react-router-dom";
import useLocalStorage from "../../../../services/useLocalStorage";
import { play, DEFAULT_VOLUME } from "../../Audio/Audio";
import GameLoading from "../../Loading";
import { GameState, PLAYER_KEY, VOLUME_KEY, BALL_COUNT_KEY } from "../../../../types/GameTypes";
import RadioButtonGroup from "../../../UI/RadioButtonGroup";

import "./Form.scss";

type FormValues = {
  player: string;
  ballCount: number;
  volume: number;
};

const ErrorText: React.FC = (props) => {
  return <div className="error-text">{props.children}</div>;
};

function GameDialogForm() {
  const [{ loading }, setStartGameResult] = useState<FetchResult<GameState>>({ loading: false });

  const { register, handleSubmit, errors, control } = useForm<FormValues>();

  const [playerName, setPlayerName] = useLocalStorage(PLAYER_KEY, "");
  const [ballCount, setBallCount] = useLocalStorage(BALL_COUNT_KEY, 4);
  const [volume, setVolume] = useLocalStorage(VOLUME_KEY, DEFAULT_VOLUME);

  let history = useHistory();

  const onSubmit = async (values: FormValues) => {
    setPlayerName(values.player);
    setBallCount(values.ballCount);
    setVolume(values.volume);
    const result = await startGame(values.player, +values.ballCount, setStartGameResult);

    if (result.error) {
      play("DRAMA");
      toast.error(result.error.message, { autoClose: false });
    }

    if (result.data) {
      const game = result.data;
      if (game.state !== "VOID") {
        play("BEEP_BEEP");
        history.push(`/game/${game.nonce}`);
      }
    }
  };

  return (
    <>
      {loading ? (
        <GameLoading />
      ) : (
        <form className="game-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group player">
            <input
              autoFocus
              type="text"
              className={errors.player ? "error" : ""}
              name="player"
              placeholder="player name"
              ref={register({ required: true })}
              maxLength={16}
              defaultValue={playerName}
            />
            {errors.player && <ErrorText>Who are you?</ErrorText>}
          </div>

          <div className="form-group ball-count">
            <label>ball count</label>
            <RadioButtonGroup
              name="ballCount"
              initValue={`${ballCount}`}
              innerRef={register}
              items={[
                { id: "3-balls", value: "3", label: "3" },
                { id: "4-balls", value: "4", label: "4" },
                { id: "5-balls", value: "5", label: "5" },
              ]}
            />
          </div>

          <div className="form-group volume">
            <label>volume</label>
            <Controller
              as={UIRangeControl}
              name="volume"
              min="0"
              max="10"
              step="1"
              control={control}
              innerRef={register}
              defaultValue={volume}
            />
          </div>

          <div className="form-group button-bar">
            <button type="submit" className="game-button">
              Start
            </button>
          </div>
        </form>
      )}
    </>
  );
}

export default GameDialogForm;
